'use client';

import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { photoCarouselSlideRecipe } from './styles/photo-carousel-slide.styles';
import type { PhotoCarouselSlidePropsInterface } from './types/photo-carousel-slide.types';

/**
 * An individual slide in a PhotoCarousel.
 *
 * @since 8.66.0
 */

export const PhotoCarouselSlide = forwardRef<HTMLDivElement, PhotoCarouselSlidePropsInterface>(
  (props: PhotoCarouselSlidePropsInterface, forwardedRef) => {
    const {
      className,
      css: cssProp,
      shouldAnimateTranslations = true,
      slidePosition,
      ...rest
    } = props;

    const styles = css(
      photoCarouselSlideRecipe.raw({ shouldAnimateTranslations, slidePosition }),
      cssProp,
    );

    return (
      <div
        className={cx('c11n', styles, className)}
        data-c11n-component="PhotoCarousel.Slide"
        ref={forwardedRef}
        role="tabpanel"
        {...rest}
      />
    );
  },
);

PhotoCarouselSlide.displayName = 'PhotoCarousel.Slide';
